/**
 * Marketing-site URL the portal links back to (logo when signed out,
 * "apply" pointers on /sign-in, etc.).
 *
 * Default is **derived from the portal's own host at runtime** — the marketing
 * apex is the portal host minus its `app.` subdomain (e.g. portal on
 * `app.truecarepartners.cc` → marketing `https://truecarepartners.cc`). So no
 * per-environment marketing hostname is baked, and `.cc`/`.ca`/preview all
 * "just work" with zero config. `PUBLIC_MARKETING_URL` / `VITE_MARKETING_URL`
 * stay as optional overrides for a split dev tunnel (where marketing lives on
 * a `-dev` host that isn't a clean sibling of the portal host):
 *
 *   PUBLIC_MARKETING_URL=https://<marketing-tunnel>.trycloudflare.com \
 *     vite --host 0.0.0.0
 *
 * Phase 14a-1 — hostnames are NOT hardcoded in `branding.ts`; here they're
 * derived from the live host (or an env override), never a baked prod default.
 */
function derivedMarketingUrl(): string {
  if (typeof window === 'undefined') return '';
  const host = window.location.host.split(':')[0] ?? '';
  const labels = host.split('.');
  if (labels.length < 2) return ''; // localhost etc. — use an env override in dev
  const base = labels.slice(-2).join('.'); // registrable domain (our TLDs are 2-label)
  return `${window.location.protocol}//${base}`;
}

export const MARKETING_URL: string =
  import.meta.env['PUBLIC_MARKETING_URL'] ??
  import.meta.env['VITE_MARKETING_URL'] ??
  derivedMarketingUrl();
